// extracted by mini-css-extract-plugin
export default {"l_OptionEle_main":"OptionEle_l_OptionEle_main__x8cZh"};